import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "../../../../shared/components/Buttons/Button";
import CategoriesDropdown from "../../../../shared/components/selectDropdown/CategoriesDropdown";
import {
  buttonNameConstants,
  buttonTypeConstants,
  categoryDropdownConstants,
  toastMessages,
  toastType,
  transactionConstants,
} from "../../../../constants";
import { NFCIcon } from "../../../../assets/icons/iconsProvider";
import {
  customToast,
  isSpinnerEnabled,
  parseToThousandSeperatorDecimalNumber,
} from "../../../../shared/utility";
import { STORE_CARD_PAYMENT_TYPE_ENUMS } from "../../../../system/globalEnums";

const CardPayment = ({
  amountToPay,
  spinnerArray,
  currentStore,
  storeDevices,
  paymentDevice,
  transactionData,
  setPaymentMethod,
  handleThirdPartyPayment,
  handleCreditCardPayment,
  handleTransactionCancel,
  activeCardPaymentTypeProp,
  handleCancelButtonClick = () => {},
}) => {
  const activeCardPaymentType =
    activeCardPaymentTypeProp || currentStore?.activeCardPaymentType;

  const isSlingshotPayment =
    activeCardPaymentType === STORE_CARD_PAYMENT_TYPE_ENUMS.SLINGSHOT;
  const isVerifonePayment =
    activeCardPaymentType === STORE_CARD_PAYMENT_TYPE_ENUMS.VERIFONE;
  const isDeviceBasedPayment = isSlingshotPayment || isVerifonePayment;

  const paymentDeviceLabel = isSlingshotPayment ? "Slingshot" : "Verifone";

  const availablePaymentDevices = React.useMemo(() => {
    if (!storeDevices?.length) return [];

    return storeDevices
      .filter((device) => {
        if (isSlingshotPayment) {
          return device.deviceType === STORE_CARD_PAYMENT_TYPE_ENUMS.SLINGSHOT;
        }
        // Verifone devices have no deviceType or undefined
        return !device.deviceType;
      })
      .map((device) => ({
        value: isSlingshotPayment ? device.deviceId : device.serialNumber,
        label: device.poiId,
      }));
  }, [storeDevices, isSlingshotPayment]);

  const [selectedDevice, setSelectedDevice] = useState(
    availablePaymentDevices.length > 0 ? availablePaymentDevices[0] : null
  );

  const handlePayFromDeviceClick = () => {
    if (selectedDevice?.value) {
      handleCreditCardPayment(selectedDevice?.value);
    } else {
      customToast(toastMessages.PLEASE_SELECT_DEVICE, toastType.ERROR);
    }
  };

  const handleContinueButtonClick = () => {
    handleThirdPartyPayment();
  };

  const handleCancelBtnClick = () => {
    setPaymentMethod("");
    handleCancelButtonClick();
  };

  return (
    <div className="payment-cash-card-wrapper">
      <Row className="m-0">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <span className="cash-heading">Credit</span>
          {amountToPay < transactionData.totalAmountToPay && (
            <span className="item-count-chip">
              ${parseToThousandSeperatorDecimalNumber(amountToPay)}
            </span>
          )}
        </Col>
        {isDeviceBasedPayment ? (
          <Col md={12} className="mt-3">
            {paymentDevice ? (
              <div className="receipt-total-wrapper d-flex flex-column justify-content-center align-items-center gap-3 p-5">
                <NFCIcon />
                <span className="verifone-heading">
                  Use {paymentDeviceLabel} device to complete transaction
                </span>
                <Button
                  type="button"
                  label={buttonNameConstants.CANCEL_THE_TRANSACTION}
                  handleClick={handleTransactionCancel}
                  buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                  className="w-100"
                />
              </div>
            ) : (
              <>
                <div className="receipt-total-wrapper d-flex flex-column gap-1">
                  <span>Select {paymentDeviceLabel} Device</span>
                  <CategoriesDropdown
                    className="w-100 mt-1"
                    options={availablePaymentDevices}
                    handleChange={setSelectedDevice}
                    noOptionsMessage="No Device Found"
                    placeholder="Select Payment Device"
                    SelectIconImage={categoryDropdownConstants.POS_DEVICE_ICON}
                    isClearable={false}
                    defaultValue={availablePaymentDevices[0] || null}
                  />
                </div>
                <Button
                  type="button"
                  label={buttonNameConstants.PAY}
                  handleClick={handlePayFromDeviceClick}
                  className="w-100 mt-2"
                />
                <Button
                  type="button"
                  label={buttonNameConstants.CANCEL}
                  handleClick={handleCancelBtnClick}
                  buttonType={buttonTypeConstants.GHOST_BUTTON}
                  className="w-100 mt-2"
                />
              </>
            )}
          </Col>
        ) : (
          <Col md={12}>
            <div className="w-100 p-3 d-flex justify-content-center align-items-center">
              <span className="w-100 p-3 text-center">
                Use Card Reader to Capture Payment
              </span>
            </div>
            <Button
              type="button"
              label={buttonNameConstants.CONTINUE}
              handleClick={handleContinueButtonClick}
              isDisabled={
                isSpinnerEnabled(
                  spinnerArray,
                  transactionConstants.GET_RETURN_ID
                ) ||
                isSpinnerEnabled(
                  spinnerArray,
                  transactionConstants.MAKE_TRANSACTION
                )
              }
              className="w-100 mt-2"
            />
            <Button
              type="button"
              label={buttonNameConstants.CANCEL}
              handleClick={handleCancelBtnClick}
              buttonType={buttonTypeConstants.GHOST_BUTTON}
              className="w-100 mt-2"
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default CardPayment;
